module.exports = __webpack_public_path__ + "live-tip-warning-63dcc696.png";